import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import HeaderNav from "@/components/HeaderNav";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { nav("/pricing"); return; }
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          await refresh();
          setStatus("paid");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) {
          setStatus("failed"); return;
        }
      } catch (err) {
        // Poll failures are expected (Stripe not synced yet). Warn once for observability.
        console.warn("payment status poll failed, retrying:", err?.message || err);
      }
      tries += 1;
      if (tries < 20) setTimeout(tick, 2000);
      else setStatus("timeout");
    };
    tick();
    // eslint-disable-next-line
  }, [sid]);

  return (
    <div className="min-h-screen">
      <HeaderNav/>
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        {status === "checking" && (
          <>
            <Loader2 size={48} className="mx-auto animate-spin text-[var(--forest)]"/>
            <h1 className="font-display text-3xl font-black mt-4">Confirming your payment…</h1>
            <p className="text-[var(--stone)] mt-2">Give us a few seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={64} className="mx-auto text-[var(--forest)]"/>
            <h1 className="font-display text-4xl font-black mt-4">Welcome to Pro.</h1>
            <p className="text-[var(--stone)] mt-2">Blueprints, tracker, and all matches — unlocked.</p>
            <button onClick={()=>nav("/app")} className="btn-primary mt-8" data-testid="go-dashboard-btn">
              Go to my dashboard
            </button>
          </>
        )}
        {(status === "failed" || status === "timeout") && (
          <>
            <h1 className="font-display text-3xl font-black">Something didn't stick.</h1>
            <p className="text-[var(--stone)] mt-2">Try again or contact support.</p>
            <button onClick={()=>nav("/pricing")} className="btn-primary mt-8">Back to pricing</button>
          </>
        )}
      </div>
    </div>
  );
}
